import { gql } from '@apollo/client';

export const UPDATE_INTERNAL_MOBILITY_IMAGE = gql`
	mutation UpdateCompany($input: UpdateCompanyInput!) {
		updateCompany(input: $input) {
			id
			internalMobilityImage {
				bucket
				region
				key
			}
		}
	}
`;

export const QUERY_INTERNAL_MOBILITY = gql`
	query QueryInternalMobilityByCompanyIdIndex(
		$companyId: ID!
		$first: Int
		$after: String
	) {
		queryInternalMobilityByCompanyIdIndex(
			companyId: $companyId
			first: $first
			after: $after
		) {
			items {
				id
				companyId
				contentFirst
				contentMiddle
				contentLast
				hideOpenToNewRoles
				hideResources
			}
			nextToken
		}
	}
`;

export const CREATE_INTERNAL_MOBILITY = gql`
	mutation CreateInternalMobility($input: CreateInternalMobilityInput!) {
		createInternalMobility(input: $input) {
			id
			companyId
			contentFirst
			contentMiddle
			contentLast
			hideOpenToNewRoles
			hideResources
		}
	}
`;

export const UPDATE_INTERNAL_MOBILITY = gql`
	mutation UpdateInternalMobility($input: UpdateInternalMobilityInput!) {
		updateInternalMobility(input: $input) {
			id
			companyId
			contentFirst
			contentMiddle
			contentLast
			hideOpenToNewRoles
			hideResources
		}
	}
`;

export const GET_JOB_REFERRAL_CONTACTS = gql`
	query GetJob($id: ID!) {
		getJob(id: $id) {
			id
			referrals {
				contact {
					emailAddress
				}
			}
		}
	}
`;

export const CREATE_CONTACT = gql`
	mutation CreateContact($input: CreateContactInput!) {
		createContact(input: $input) {
			id
			emailAddress
		}
	}
`;

export const UPDATE_CONTACT = gql`
	mutation UpdateContact($input: UpdateContactInput!) {
		updateContact(input: $input) {
			id
			contactResume {
				bucket
				region
				key
			}
		}
	}
`;

export const CREATE_REFERRAL = gql`
	mutation CreateReferral($input: CreateReferralInput!) {
		createReferral(input: $input) {
			id
			companyId
			contactId
			userId
			jobId
			status
			referralType
			referralDate
		}
	}
`;

export const QUERY_JOB_MATCHES_BY_USER = gql`
	query QueryJobMatchesByUserIdIndex(
		$userId: ID!
		$first: Int
		$after: String
	) {
		queryJobMatchesByUserIdIndex(
			userId: $userId
			first: $first
			after: $after
		) {
			items {
				id
				active
				companyId
				jobId
				matchType
				relevance
				job {
					id
					companyId
					title
					description
					location
					departmentId
					department {
						id
						name
					}
					externalJobId
					hideImInterested
					internalJobLink
				}
			}
			nextToken
		}
	}
`;

export const QUERY_SELF_REFERRALS = gql`
	query QueryReferralsByUserIdReferralTypeIndex(
		$userId: String!
		$referralType: String!
		$limit: Int
		$nextToken: String
	) {
		queryReferralsByUserIdReferralTypeIndex(
			userId: $userId
			referralType: $referralType
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				customStatus
				id
				job {
					id
					internalJobLink
					location
					title
				}

				referralDate
				referralType
				status
				userId
			}
			nextToken
		}
	}
`;
